<section class="py-4 header">
  <div class="container py-4">

      <div class="row">
          <div class="col-md-3" *ngIf="routesService.isOnMobileDevice">
              <div class="nav flex-column nav-pills nav-pills-custom">
                  <a class="nav-link mb-3 p-3 shadow active pointer" href="dar#transfer" [ngClass]="{'active': actualOption === 1}" (click)="optionSelected(1)">
                      <span class="font-weight-bold small text-uppercase">Transferencias a un mismo banco</span></a>

                  <a class="nav-link mb-3 p-3 shadow pointer" href="dar#transfer-inter" [ngClass]="{'active': actualOption === 2}" (click)="optionSelected(2)">
                      <span class="font-weight-bold small text-uppercase">Transferencias &nbsp;Interbancarias</span></a>

                  <a class="nav-link mb-3 p-3 shadow pointer" href="dar#paypal" [ngClass]="{'active': actualOption === 3}" (click)="optionSelected(3)">
                      <span class="font-weight-bold small text-uppercase">Paypal</span></a>

                  <a class="nav-link mb-3 p-3 shadow pointer" href="dar#person" [ngClass]="{'active': actualOption === 4}" (click)="optionSelected(4)">
                      <span class="font-weight-bold small text-uppercase">En persona</span></a>
              </div>
          </div>
          <div class="col-md-3" *ngIf="!routesService.isOnMobileDevice">
              <div class="nav flex-column nav-pills nav-pills-custom">
                  <a class="nav-link mb-3 p-3 shadow active pointer" [ngClass]="{'active': actualOption === 1}" (click)="optionSelected(1)">
                      <span class="font-weight-bold small text-uppercase">Transferencias a un mismo banco</span></a>

                  <a class="nav-link mb-3 p-3 shadow pointer" [ngClass]="{'active': actualOption === 2}" (click)="optionSelected(2)">
                      <span class="font-weight-bold small text-uppercase">Transferencias &nbsp;Interbancarias</span></a>

                  <a class="nav-link mb-3 p-3 shadow pointer" [ngClass]="{'active': actualOption === 3}" (click)="optionSelected(3)">
                      <span class="font-weight-bold small text-uppercase">Paypal</span></a>

                  <a class="nav-link mb-3 p-3 shadow pointer" [ngClass]="{'active': actualOption === 4}" (click)="optionSelected(4)">
                      <span class="font-weight-bold small text-uppercase">En persona</span></a>
              </div>
          </div>
          <div class="col-md-9">
              <!-- Tabs content -->
              <div class="tab-content"  id="tab-content">
                <div class="tab-pane fade shadow rounded bg-white show p-5" [ngClass]="{'active show': actualOption === undefined}">
                    <h4 class="font-italic mb-4">Selecciona una de las opciones</h4>
                    <p class="font-italic text-muted mb-2">Tenemos las siguientes formas en las que puedes dar tus diezmos, ofrendas.<br><br>
                    Cada uno debe dar seg&uacute;n crea que deba hacerlo. No tenemos que dar con tristeza ni por obligaci&oacute;n. ¡Dios ama al que da con alegr&iacute;a!
                <br><b> 2 Corintios 9:7</b></p>
                </div>
                <div class="tab-pane fade shadow rounded bg-white show p-5" id="transfer" [ngClass]="{'active show': actualOption === 1}">
                      <h4 class="font-italic mb-4">Puedes hacer una transferencia a las siguientes cuentas</h4>
                      <p class="font-italic text-muted mb-2 text-left">
                          <li class="pt-1">1911-5735-601045 <b> S/ (Bcp)</b></li>
                          <li class="pt-1">1919-2002-090102 <b> US$ (Bcp)</b></li>
                          <li class="pt-1">8983-1514-32362 <b> S/ (Interbank)</b></li>
                          <li class="pt-1">0011-0174-0200711995 <b>S/ (Bbva)</b></li>
                      </p>
                </div>
                  
                  <div class="tab-pane fade shadow rounded bg-white p-5"  id="transfer-inter" [ngClass]="{'active show': actualOption === 2}">
                    <h4 class="font-italic mb-4">Puedes hacer una transferencia interbancaria a las siguientes cuentas</h4>
                    <p class="font-italic text-muted mb-2 text-left">
                        <li class="pt-1">002-191-115735601045-51 <b> S/ (Bcp)</b></li>
                        <li class="pt-1">002-191-192002090102-59 <b> US$ (Bcp)</b></li>
                        <li class="pt-1">003-898-013151432362-48 <b> S/ (Interbank)</b></li>
                        <li class="pt-1">011-174-000200711995-07 <b> S/ (Bbva)</b></li>
                    </p>
                  </div>
                  
                  <div class="tab-pane fade shadow rounded bg-white p-5" id="paypal" [ngClass]="{'active show': actualOption === 3}">
                      <h4 class="font-italic mb-4">Haz tu donativo por aquí </h4>
                        <a href="https://paypal.me/ccancla" target="_blank"class="paypal-button">Paypal</a>
                    </div>
                  
                  <div class="tab-pane fade shadow rounded bg-white p-5" id="person" [ngClass]="{'active show': actualOption === 4}">
                      <h4 class="font-italic mb-4">Ac&eacute;rcate a nuestro templo </h4>
                      <p class="font-italic text-muted mb-2">Te dejamos la direcci&oacute;n y unos enlaces para que puedas venir y dejar tu diezmo y ofrenda:
                        <br> <strong>Calle Loa #36 - Anc&oacute;n 15123</strong>
                      </p>
                      <a class="btn btn-light maps-button" href="https://goo.gl/maps/KZ9c7Y1oDdFc6PdQA" target="_blank" type="button" role="button">
                        <img src="assets/social-media-icons/google-maps.png" height="30px">Google maps</a>
                      <a class="btn btn-light maps-button" href="https://ul.waze.com/ul?place=ChIJededzvR_BpERole0pRxRBOY&ll=-11.77495230%2C-77.17168730&navigate=yes" role="button" target="_blank" type="button">
                        <img src="assets/social-media-icons/waze.png" height="30px">Waze</a>
                  </div>
              </div>
          </div>
      </div>
  </div>
</section>